// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"6da3cd5c","132":"46543430","453":"e4a14831","501":"f40dffc0"}[chunkId] + ".chunk.js";
};